import React from 'react';

function XTab(props) {
	const row_classes = props.row_classes || ["pb-4"];
	const add_classes = props.add_classes || [""];
	const spacing_classes = props.spacing_classes || ["px-2"];

	var selected_left_index = props.left_selected || props.selected || 0;
	var selected_right_index = props.right_selected || 0;
	var i, classes;

	const left_tabs = props.left_tabs || props.tabs || [];
	var left_tab_elements = [];
	for (i = 0; i < left_tabs.length; i++) {
		const tab = left_tabs[i];

		if (!tab) continue;

		classes = [...add_classes];
		if (i === selected_left_index) {
			classes.push("ad_xtab_selected");
			left_tab_elements.push(
				<span key={`il${i}`} className={classes.join(" ")}>{tab}</span>
			);
		} else {
			classes.push("ad_xtab_unselected ad_xtab_clickable");
			const onSelect = ((i) => () => {
				if (props.onLeftSelect) props.onLeftSelect(i);
				if (props.onSelect) props.onSelect(i);
			})(i);
			left_tab_elements.push(
				<span key={`il${i}`} role="button" tabIndex="0" onClick={onSelect} onKeyPress={onSelect} className={classes.join(" ")}>{tab}</span>
			);
		}

		/* spacing between tabs */
		classes = ["ad_xtab_unselected", ...spacing_classes, ...add_classes];
		left_tab_elements.push(
			<span key={`sl${i}`} className={classes.join(" ")}></span>
		);
	}

	const right_tabs = props.right_tabs || [];
	var right_tab_elements = [];
	for (i = 0; i < right_tabs.length; i++) {
		const tab = right_tabs[i];

		if (!tab) continue;

		/* spacing between tabs */
		classes = ["ad_xtab_unselected", ...spacing_classes, ...add_classes];
		right_tab_elements.push(
			<span key={`sr${i}`} className={classes.join(" ")}></span>
		);

		classes = [...add_classes];
		if (i === selected_right_index) {
			classes.push("ad_xtab_selected");
			right_tab_elements.push(
				<span key={`ir${i}`} className={classes.join(" ")}>{tab}</span>
			);
		} else {
			classes.push("ad_xtab_unselected ad_xtab_clickable");
			const onSelect = ((i) => () => {
				if (props.onRightSelect) props.onRightSelect(i);
			})(i);
			right_tab_elements.push(
				<span key={`ir${i}`} role="button" tabIndex="0" onClick={onSelect} onKeyPress={onSelect} className={classes.join(" ")}>{tab}</span>
			);
		}
	}

	return (
		<div className={["d-flex", ...row_classes].join(" ")}>
			{left_tab_elements}
			<span className={["ad_xtab_unselected", "flex-grow-1", ...add_classes].join(" ")}></span>
			{right_tab_elements}
		</div>
	);
}

export default XTab;



// WEBPACK FOOTER //
// ./src/c/XTab.js